import React from "react";
import './App.scss';
import 'mapbox-gl/dist/mapbox-gl.css';
import {
  HashRouter as Router,
  Switch,
  Route
} from "react-router-dom";

import Home from './components/organisms/home/Home'
import About from './components/organisms/about/About'
import Tutorial from './components/organisms/tutorial/Tutorial'
import Contact from './components/organisms/contact/Contact'

// Sets the overall structure of the app. Each tab his contained in their own file
function App() {
  return (
    <Router basename={""}>
      <div className="App">
        <div className="MainContainer">
        <Switch>
          <Route path="/contact">
            <Contact />
          </Route>
          <Route path="/about">
            <About />
          </Route>
          <Route path="/tutorial">
            <Tutorial />
          </Route>
          <Route path="/">
            <Home />
          </Route>
        </Switch>
        </div>
      </div>
    </Router>
  );
}

export default App;
